// 适用于 Vue2 的事件总线实现
import Vue from 'vue'

// 创建一个空的 Vue 实例作为事件总线
const EventBus = new Vue()

// 封装常用方法，方便调用
export default {
  // 监听事件
  on(eventName, callback) {
    EventBus.$on(eventName, callback)
  },
  
  // 监听一次事件（触发后自动移除）
  once(eventName, callback) {
    EventBus.$once(eventName, callback)
  },
  
  // 触发事件
  emit(eventName, ...args) {
    EventBus.$emit(eventName, ...args)
  },
  
  // 移除事件监听
  off(eventName, callback) {
    // 如果没有指定回调，移除该事件的所有监听
    if (typeof callback === 'undefined') {
      EventBus.$off(eventName)
    } else {
      EventBus.$off(eventName, callback)
    }
  }
}